<template>
    <div class="search_form">
        <div class="search_filed">
            <b-input-group>
                <b-input-group-text slot="prepend" >
                    {{__t('FIND_GROUP')}}
                </b-input-group-text>

                <b-form-input v-model="search"></b-form-input>
            </b-input-group>
        </div>

        <b-overlay :show="is_load">
            <groups_list :groups="grouplist"></groups_list>
        </b-overlay>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'groups/getUfilterField',
    mutationType: 'groups/updateUfilterField',
});
import Groups_list from "../list/groups_list.vue";

export default {
    name: "search",
    components : {
        Groups_list

    },
    data() {
        return {
            is_load: false,
            form : {
                search : '',
                cur_type : 'search'
            },
        }
    },
    created() {
        this.load_groups();
    },


    methods: {
        async load_groups() {

            this.$store.dispatch('groups/SET_GROUPS_LIST', []);
            if (this.search.length > 2) {
                this.is_load = true;
                await api.post('/internal/v1/catalog/modifiers/groups', this.send_form).then(({data}) => {
                    this.$store.dispatch('groups/SET_GROUPS_LIST', data.data);
                    this.is_load = false;

                }).catch(err => {
                    this.is_load = false;
                });
            }
        }
    },

    computed: {
        ...mapFields([
            'search',
            'groups',
        ]),

        send_form () {
            this.form.search = this.search;
            return this.form;
        },

        grouplist () {
            return  this.groups;
        }
    },

    watch: {
        'search': function () {
            if(this.search.length > 2) {
                this.load_groups();
            }
            else {
                this.$store.dispatch('groups/SET_USERS_LIST', []);
            }
        },
    }
}
</script>

<style scoped>

</style>
